
import de from './lang/de.json';
import en from './lang/en.json';

export default {
  de,
  en,
};
